import { createFileRoute } from "@tanstack/react-router";

import { CatalogRoute } from "../screens/catalog-route";

export const Route = createFileRoute("/suppliers")({
  component: () => <CatalogRoute path="/suppliers" kind="Supplier" />,
});
